import {emptySplitApi, providesTagsList, queryStarted} from "./api";

export const locationApi = emptySplitApi.injectEndpoints({
    endpoints: (builder) => ({
        listLocations: builder.query({
            query: () => ({
                url: 'company/location/list',
                method: 'GET'
            }),
            providesTags: (result) => providesTagsList('Location', result)
        }),
        getLocation: builder.query({
            query: (id) => `company/location/${id}`,
            providesTags: (result, error, id) => [{ type: 'Location', id }]
        }),
        createLocation: builder.mutation({
            query: (data) => ({
                url: 'company/location/create',
                method: 'POST',
                body: data
            }),
            invalidatesTags: [{ type: 'Location', id: 'LIST' }]
        }),
        updateLocation: builder.mutation({
            query: ({id, ...data}) => ({
                url: `company/location/update/${id}`,
                method: 'PUT',
                body: data
            }),
            onQueryStarted: (args, api) => queryStarted(args, api, 'getLocation'),
            invalidatesTags: (result, error, { id }) => [{ type: 'Location', id }]
        })
    })
});

export const {
    useListLocationsQuery,
    useGetLocationQuery,
    useCreateLocationMutation,
    useUpdateLocationMutation
} = locationApi;